const Blank = [
    {
      creationDate: "",
      name: "",
      authorName: "",
      assignments: 
        [{
          quiz : [
            {
              answerType: 0,
              ratingValue: 5,
              questionText: `Which of the following nodes is an abbreviation for?`,
              answerText: '',
              answerOptions: [
                // { answerText: '', isCorrect: true },
                // { answerText: '', isCorrect: false },
                // { answerText: '', isCorrect: true },
                // { answerText: '', isCorrect: false },
                    ]
            },
              {
                answerType: 0,
                ratingValue: 5,
                questionText: `Which of the following nodes best reflects this statement?`,
                answerText: '',
                answerOptions: [
                  // { answerText: '', isCorrect: true },
                  // { answerText: '', isCorrect: false },
                  // { answerText: '', isCorrect: true },
                  // { answerText: '', isCorrect: false },
                      ]
            },
              {
                answerType: 0,
                ratingValue: 5,
                questionText: `Select the node that is most related to this...?`,
                answerText: '',
                answerOptions: [
                  // { answerText: '', isCorrect: true },
                  // { answerText: '', isCorrect: false },
                  // { answerText: '', isCorrect: true },
                  // { answerText: '', isCorrect: false },
                      ]
            },
        
          ],

          essay: [
            {
              questionText: `Please select two nodes and write about their relationship. Extra points available for referencing and attaching an image!`,
            },
            {
              questionText: `Please select another two nodes and write about their relationship. Extra points available for referencing and attaching an image!`,
            },
            {
              questionText: `Please summarise an overall picture of this module's content and your learnings from this content. Extra points available for referencing and attaching an image!`,
            },
          
          ],
          ratings: [
            {
              questionText: "How would you rate the learning content in this study module?"
            },
            {
              questionText: "How would you rate the your own motivation?"
            },
            {
              questionText: "How likely would you recommend this content to anyone?"
            },
            {
              questionText: "Was the content provided anything like you expected?"
            },
            {
              questionText: "Thank you for your feedback!"
            },
          ]
      }],
      data: [
        {
          name: "",
          value: 0,
          // uid: uuid(),
          index: 0,
          description: "Please proceed by adding a description of this Parent node",
          additionalMaterial: {
            link: "",
            photo: null,
            video: "",
          },
          children: [
            {
              masterIndex: 0,
              parentIndex: 0,
              index: 0,
              name: "",
              value: 0,
              strength: 1,
              description: "Please proceed by adding a description of this Child node",
              // uid: uuid(),
              children: [
                { 
                  masterIndex: 0,
                  parentIndex: 0,
                  index: 0,
                  name: "", 
                  value: 0, 
                  strength: 1,
                  description: "Please proceed by adding a description of this Sub node",
                  // uid: uuid(),
                }
              ]
            }
          ]
        }
      ],
      


    }
  ];

  export default Blank;